import { render, staticRenderFns } from "./ParametersTable.vue?vue&type=template&id=a92b56f4&scoped=true&"
import script from "./ParametersTable.vue?vue&type=script&lang=js&"
export * from "./ParametersTable.vue?vue&type=script&lang=js&"
import style0 from "./ParametersTable.vue?vue&type=style&index=0&id=a92b56f4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92b56f4",
  null
  
)

export default component.exports